import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '@global/Api';
import { RootState } from '@global/store/store';

import { UPDATE_BILLING_INFORMATION } from '@global/requests/checkout/UPDATE_BILLING_INFORMATION';

import { buildVariablesForUpdateBillingInfo } from '@pages/checkout/components/BillingInformation/helper';
import { getOrderPrice, OrderPriceType } from '@global/utils/orderUtils';
import { IBillingInfo } from '@global/types/types';

export const updateBillingInformation = createAsyncThunk<
  {
    orderPrice: OrderPriceType;
    billingInfo: IBillingInfo;
  },
  {
    dataBillingInfo: IBillingInfo;
  },
  { rejectValue: string }
>(
  'cart/updateBillingInformation',
  async ({ dataBillingInfo }, { rejectWithValue, getState }) => {
    try {
      const { cart } = getState() as RootState;

      if (cart.isSubscriptionExist && !cart.agreementCheck) {
        throw new Error(`"agreement check" should be true`);
      }

      const variables = buildVariablesForUpdateBillingInfo(
        dataBillingInfo,
        cart.cartId,
        cart.agreementCheck
      );

      const result = await client.mutate({
        mutation: UPDATE_BILLING_INFORMATION,
        variables,
      });

      return {
        orderPrice: getOrderPrice(
          result.data?.updateViaxCustomerOrder?.pricPrice?.edges
        ),
        billingInfo: dataBillingInfo,
      };
    } catch (error) {
      console.error(error);
      return rejectWithValue('SERVER ERROR');
    }
  }
);
